import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDialogVisible } from "../../actions/session";
import { Dialog } from "../Dialog";
import { DialogContainer } from "../DialogContainer";
import { OverlayContainer } from "../OverlayContainer";
/**
 * Provides a dialog system layer.
 * For both layouts.
 */
export const DialogLayer = () => {
    const dispatch = useDispatch();
    const visibleDialog = useSelector((state) => state.session.base.visibleDialog || undefined);
    const onHideDialog = useCallback(() => {
        dispatch(setDialogVisible(undefined));
    }, [dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, null),
        React.createElement(DialogContainer, { visibleDialog: visibleDialog, onHideDialog: onHideDialog }),
        React.createElement(OverlayContainer, null)));
};
